"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ({ isEditing, }) => {
    return {
        schemaType: "object",
        properties: [
            {
                title: "言語",
                propertyName: "langId",
                schema: {
                    schemaType: "externalKey",
                    resourcePath: "translation_lang",
                    uiType: "normal",
                    titleKey: "langName",
                    readOnly: isEditing,
                },
            },
            {
                title: "詳細",
                propertyName: "description",
                schema: {
                    schemaType: "text",
                },
            },
            {
                title: "言語の別名",
                propertyName: "aliases",
                schema: {
                    schemaType: "array",
                    defaultValue: "",
                    item: {
                        schemaType: "text",
                    },
                },
            },
        ],
    };
};
